import React from 'react';
import { NormalButton } from '@/shared/ui';
import { URL_CALLCENTER_PORTAL } from '@/shared/config';
import icNotFound from '@/shared/ui/icons/Components/Status/ic-not-found.svg';
import './styles.scss';

export type LoadingResetStudyProps = {
  onClick?: (e: React.MouseEvent) => void;
};

/**
 * Renders the placeholder screen shown while a study's data is being reset. Falls back to navigating to the call center portal when no onClick handler is supplied for the back button.
 *
 * @param onClick - Handler for the back button; when omitted the portal URL is used.
 * @returns The rendered reset-in-progress screen.
 */
const LoadingResetStudy = ({ onClick }: LoadingResetStudyProps) => {
  /**
   * Sends the reviewer back to the call center portal. Assigns URL_CALLCENTER_PORTAL to the document location.
   *
   * @returns Nothing.
   */
  const defaultOnClick = () => {
    document.location.href = URL_CALLCENTER_PORTAL;
  };

  return (
    <div className="loading-reset-study-page">
      <div className="block-center">
        <img src={icNotFound} alt="not found" />
        <div className="main-text">Reset in progress...</div>
        <div className="sub-text">The study data is being reset.</div>
        <NormalButton buttonName="Back to Call Center Portal" onClick={onClick ?? defaultOnClick} />
      </div>
    </div>
  );
};

export default LoadingResetStudy;
